import React, { useState } from "react";
import { useParams } from "react-router-dom";
import DriverViewStatus from "./DriverViewStatus";
import Tab from "reusable/tab";
import DriverAlcoholSubmissionsTable from "./DriverViewTable/DriverAlcoholSubmissionsTable";
import DriverWorkingAttendanceTable from "./DriverViewTable/DriverWorkingAttendanceTable";
import DriverDetailTable from "./DriverViewTable/DriverDetailTable";
import DriverLicenseSubmissionsTable from "./DriverViewTable/DriverLicenseSubmissionsTable";
import DriverHealthCheckTable from "./DriverViewTable/DriverHeatlhCheckTable";
import DriverWorkingRecordTable from "./DriverViewTable/DriverWorkingRecordTable";
import { useTranslation } from 'react-i18next';


const DriverView: React.FC = () => {
    const { t, i18n } = useTranslation('driver');
    const tabsData = [
        { label: `${t('view.alcohol-submission.title')}`, value: 'alcoholsubmission' },
        { label: `${t('view.working-attendance.title')}`, value: 'workingattendance' },
        { label: `${t('view.working-record.title')}`, value: 'workingrecord' },
        { label: `${t('view.license-submission.title')}`, value: 'licensesubmission' },
        { label: `${t('view.health-check.title')}`, value: 'healthcheck' },
        { label:`${t('view.driver-detail.title')}`, value: 'driverdetail' },
    ];
    const [activeTab, setActiveTab] = useState<string>(tabsData[0].value);
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);

    const handleTabClick = (value: string) => {
        setActiveTab(value);
        setCurrentPage(1);
    };

    const { id } = useParams<{ id: string }>();

    return (
        <main className="px-4 py-3 space-y-3">
            <h6 className="font-bold text-title">{t('title.title')}</h6>
            <div className="flex">
                <DriverViewStatus id={id}/>
            </div>
            <div className="bg-white rounded-md px-4 py-2 space-y-2">
               {/* Tab Section */}
                <div>
                    <Tab tabs={tabsData} onTabClick={handleTabClick} />
                </div>
                {/* Loading Indicator */}
                <div>
                {loading ? (
                    <div className="flex justify-center items-center" style={{ height: '73vh' }}>
                        <div>Loading...</div>
                    </div>
                ) : (
                    <div>
                    {/* Table Section */}
                        {activeTab === 'alcoholsubmission' && <DriverAlcoholSubmissionsTable id={id} />}
                        {activeTab === 'workingattendance' && <DriverWorkingAttendanceTable id={id}/>}
                        {activeTab === 'workingrecord' && <DriverWorkingRecordTable id={id}/>}
                        {activeTab === 'licensesubmission' && <DriverLicenseSubmissionsTable id={id}/>}
                        {activeTab === 'healthcheck' && <DriverHealthCheckTable id={id}/>}
                        {activeTab === 'driverdetail' && <DriverDetailTable id={id}/>}
                    </div>
                )}
                </div>
                
            </div>
        </main>
    );
};

export default DriverView;